import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import "./style.scss";
import MainPanelHeader from "../../../layouts/mainPanelHeader";
import PanelRightContent from "../../../layouts/mainPanel/PanelRightContent";
import { ReactComponent as CommentsLog } from "../../../asset/icons/comments-log.svg";
import { useTranslation } from "react-i18next";
import { useRequest } from "../../../hooks/helperData/useRequest";
import { SURVEY_INVITATIONS } from "../../../helperData/ApiAddress";
import DBSpinner from "../../../component/global/DBSpinner";
import Surveys from "../../surveys";

function SurveyList({ items, loading, loadError, emptyKey, showAnswer, t }) {
    if (loading) {
        return <DBSpinner tip={t("loading")} />;
    }
    if (loadError) {
        return (
            <div className="survey-invitations-empty">
                {t("survey.invitations.load.error")}
            </div>
        );
    }
    if (!items.length) {
        return (
            <div className="survey-invitations-empty">{t(emptyKey)}</div>
        );
    }
    return (
        <div className="survey-invitations-list">
            {items.map((invitation) => (
                <div className="survey-invitation-card" key={invitation.token}>
                    <div>
                        <strong>{invitation.survey_title}</strong>
                        {invitation.survey_description && (
                            <p>{invitation.survey_description}</p>
                        )}
                        <span>
                            {[invitation.company_name, invitation.campaign_name]
                                .filter(Boolean)
                                .join(" · ")}
                        </span>
                        {Number(invitation.coins_earned) > 0 && (
                            <span className="survey-coins">
                                {t("UserPanel.Surveys.CoinsEarned", {
                                    count: invitation.coins_earned,
                                })}
                            </span>
                        )}
                    </div>
                    {showAnswer ? (
                        <Link
                            className="survey-invitation-answer"
                            to={`/survey/${invitation.token}`}
                        >
                            {t("survey.invitations.answer")}
                        </Link>
                    ) : (
                        <span className="survey-invitation-done">
                            {t("UserPanel.Surveys.Completed.Badge")}
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
}

export default function UserPoll() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("1");
    const [pending, setPending] = useState([]);
    const [completed, setCompleted] = useState([]);
    const [pendingError, setPendingError] = useState(false);
    const [completedError, setCompletedError] = useState(false);
    const [getInvitations, getInvitationsLoading] = useRequest(
        SURVEY_INVITATIONS,
        "GET"
    );
    const [getCompleted, getCompletedLoading] = useRequest(
        SURVEY_INVITATIONS,
        "GET"
    );

    useEffect(() => {
        getInvitations({ scope: "pending" })
            .then((r) => setPending(Array.isArray(r) ? r : []))
            .catch(() => setPendingError(true));
        getCompleted({ scope: "completed" })
            .then((r) => setCompleted(Array.isArray(r) ? r : []))
            .catch(() => setCompletedError(true));
    }, []);

    return (
        <div id="user-pol-con" className="main_panel_box user-poll">
            <MainPanelHeader />
            <div className="main_panel_content">
                <PanelRightContent>
                    <div className="section-title">
                        <CommentsLog />
                        <div>{t("Surveys&announcments.label")}</div>
                    </div>
                    <div className="tab-section">
                        <Tabs
                            activeKey={activeTab}
                            transition={false}
                            className="panel_tab"
                            onSelect={(key) => setActiveTab(key)}
                        >
                            <Tab
                                eventKey="1"
                                className="panel_tab_item"
                                title={t("UserPanel.Surveys.Tab.Invitations")}
                            >
                                <SurveyList
                                    items={pending}
                                    loading={getInvitationsLoading}
                                    loadError={pendingError}
                                    emptyKey="survey.invitations.empty"
                                    showAnswer
                                    t={t}
                                />
                            </Tab>
                            <Tab
                                eventKey="2"
                                className="panel_tab_item"
                                title={t("UserPanel.Surveys.Tab.Completed")}
                            >
                                <SurveyList
                                    items={completed}
                                    loading={getCompletedLoading}
                                    loadError={completedError}
                                    emptyKey="UserPanel.Surveys.Completed.Empty"
                                    showAnswer={false}
                                    t={t}
                                />
                            </Tab>
                            <Tab
                                eventKey="3"
                                className="panel_tab_item"
                                title={t("UserPanel.Surveys.Tab.Mine")}
                            >
                                <Surveys personal embedded />
                            </Tab>
                        </Tabs>
                    </div>
                </PanelRightContent>
            </div>
        </div>
    );
}
